import { makeVar, useReactiveVar } from '@apollo/client';
import { useRouter } from 'next/router';
import { type PropsWithChildren } from 'react';
import { usePreviousDifferent } from 'rooks';

const previousPathVar = makeVar<string | null>(null);

export const PreviousPathProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const previousPath = usePreviousDifferent(router.asPath ?? null);
  previousPathVar(previousPath);
  return children;
};

export function getPreviousPath() {
  return previousPathVar();
}

export function usePreviousPath() {
  return useReactiveVar(previousPathVar);
}
